import content from "../../data/content";
import "./FAQ.css";

const { faq } = content;

export default function FAQ() {
  return (
    <div className="faq-page">
      <section className="faq-header">
        <p className="page-label">FAQ</p>
        <h1 className="page-heading">{faq.heading}</h1>
        <p className="faq-sub">{faq.subheading}</p>
      </section>

      {faq.items.length > 0 && (
        <section className="faq-section">
          <div className="faq-section__inner">
            {faq.items.map((item, i) => (
              <details key={i} className="faq-item">
                <summary className="faq-item__question">
                  {item.question}
                </summary>
                <p className="faq-item__answer">{item.answer}</p>
              </details>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
